import { useScreenTracking } from "@/hooks/useScreenTracking";

export function ScreenTrackingProvider() {
  useScreenTracking();
  return null;
}
